import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import C01H from '../Input/presets/C01H_v2';
import LoadingIndicator from '../LoadingIndicator';
import Send from '../Icons/24x24/Send';
import isValidEmailAddress from '../utils/isValidEmailAddress';
import s from './VerificationEmailInput.scss';
var VerificationEmailInput = function (_a) {
    var className = _a.className, isEmailChangeInProgress = _a.isEmailChangeInProgress, isResendInProgress = _a.isResendInProgress, updateFailed = _a.updateFailed, changeEmail = _a.changeEmail;
    var t = useTranslation().t;
    var validationErrorTimeout = useRef(null);
    var _b = useState(false), validationFailed = _b[0], setValidationFailed = _b[1];
    var isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    // When validating the email input, wait 2seconds before showing any errors,
    // in order to avoid showing errors while the user is typing.
    var onInputValidate = function (isValid, value) {
        if (validationErrorTimeout.current) {
            window.clearTimeout(validationErrorTimeout.current);
            validationErrorTimeout.current = null;
        }
        if (isValid || !value) {
            setValidationFailed(false);
        }
        else {
            validationErrorTimeout.current = window.setTimeout(function () { return setValidationFailed(true); }, 2000);
        }
    };
    return (React.createElement(C01H, { placeholder: t('verification.emailInput.placeholder'), submitIcon: isEmailChangeInProgress ? (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })) : (React.createElement(Send, null)), onSubmit: changeEmail, onInputValidate: onInputValidate, inputValidator: isValidEmailAddress, className: className, loading: isChangeInProgress, errorMessage: updateFailed || validationFailed
            ? t('verification.emailInput.error')
            : undefined }));
};
export default VerificationEmailInput;
//# sourceMappingURL=VerificationEmailInput.js.map